import { stringifyQuery } from 'ufo'
import type { MaybeRefOrGetter } from 'vue'

interface Options {
  query: MaybeRefOrGetter<Record<string, any>>
}

export const createUrl = (url: MaybeRefOrGetter<string>, options?: Options) => computed(() => {
  if (!options?.query)
    return toValue(url)

  const _url = toValue(url)
  // console.debug('query: ', options?.query)
  const _query = toValue(options?.query)
  // console.debug('_query: ', _query)

  const queryObj = Object.fromEntries(
    Object.entries(_query).map(([key, val]) => {
      const curVal = toValue(val)
      if (typeof curVal === 'object') {
        return [key, undefined]
      }
      if (typeof curVal == "string") {
        if (curVal === '') {
          return [key, undefined]
        }
      }
      return [key, toCode(curVal)]
    }),
  )
    Object.entries(_query).forEach(([key, val]) => {
      const curVal = toValue(val)
      if (curVal != null && typeof curVal === 'object') {
        Object.entries(curVal).map(([subKey, subVal]) => {
          if (subVal === null || subVal === '') {
            subVal = undefined
            return [subVal, undefined]
          }
          queryObj[subKey] = subVal
          return [subKey, subVal]
        })
      }
    })

  // console.log('queryObj: ', queryObj)

  return `${_url}${queryObj ? `?${stringifyQuery(queryObj)}` : ''}`
})
